// Sma200Widget/Sma200Fetcher.js
// Singleton — does exactly 1 thing: raw I/O via HistoryService. No mapping, no business logic.
import historyService from '../../../services/HistoryService';
import CoreBase from '../../../services/engines/CoreBase';

const _name = 'Sma200Fetcher';

class Sma200Fetcher extends CoreBase {
    _name = _name;

    /**
     * Fetches the SMA200 slots for ALL assets in one call (sid=0, window=200).
     * @returns {Promise<{rk:string,root:string,sid:number,sum:number,value:number,price:number,ems:number}[]>}
     */
    fetchAll = async (limit = 10) => {
        try {
            const res = await historyService.getSmaWindow(0, 200, limit);
            return res?.data?.items ?? [];
        } catch (error) {
            this.logError('fetchAll', error.message);
            return [];
        }
    };
}

const sma200Fetcher = new Sma200Fetcher();
export default sma200Fetcher;
